// // public/src/pages/Gallery.jsx
// import React, { useState, useEffect } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { FiFilter, FiX, FiZoomIn, FiDownload } from 'react-icons/fi';
// import axios from 'axios';

// function Gallery() {
//   const [galleryItems, setGalleryItems] = useState([]);
//   const [filteredItems, setFilteredItems] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState('all');
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchGallery();
//   }, []);

//   useEffect(() => {
//     filterGallery();
//   }, [galleryItems, selectedCategory]);

//  // In Gallery.jsx, update the fetchGallery function:
// const fetchGallery = async () => {
//   try {
//     const response = await axios.get('https://agri-back-mauve.vercel.app/api/content/public/gallery');
//     if (response.data.success) {
//       const galleryItems = response.data.data;
//       setGalleryItems(galleryItems);
      
//       // Extract unique categories safely
//       const uniqueCategories = [...new Set(
//         galleryItems
//           .map(item => item.gallery?.galleryType || item.galleryType)
//           .filter(type => type) // Remove undefined/null
//       )];
//       setCategories(uniqueCategories);
//     }
//   } catch (error) {
//     console.error('Error fetching gallery:', error);
//   } finally {
//     setLoading(false);
//   }
// };

// // Also update the filter function:
// const filterGallery = () => {
//   if (selectedCategory === 'all') {
//     setFilteredItems(galleryItems);
//   } else {
//     setFilteredItems(galleryItems.filter(item => 
//       (item.gallery?.galleryType || item.galleryType) === selectedCategory
//     ));
//   }
// };

// // And update the category button to handle undefined safely:
// {categories.map(category => (
//   <button
//     key={category}
//     className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
//     onClick={() => setSelectedCategory(category)}
//   >
//     {category && category.charAt ? category.charAt(0).toUpperCase() + category.slice(1) : 'Other'}
//   </button>

  
// ))}

//   const openLightbox = (item) => {
//     setSelectedImage(item);
//   };

//   const closeLightbox = () => {
//     setSelectedImage(null);
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
//           <p>Loading gallery...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="gallery-page">
//       {/* Hero Section */}
//       <section className="page-hero bg-gradient-to-br from-purple-50 to-pink-100">
//         <div className="container">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="hero-content text-center"
//           >
//             <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
//               Project Gallery
//             </h1>
//             <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//               Visual journey through our innovative agricultural technology implementations across Africa
//             </p>
//           </motion.div>
//         </div>
//       </section>

//       {/* Category Filters */}
//       <section className="filters-section bg-white border-b py-6">
//         <div className="container">
//           <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
//             <div className="flex items-center gap-2">
//               <FiFilter className="text-gray-400" />
//               <span className="font-medium text-gray-700">Filter by:</span>
//             </div>
//             <div className="flex flex-wrap gap-2">
//               <button
//                 className={`filter-btn ${selectedCategory === 'all' ? 'active' : ''}`}
//                 onClick={() => setSelectedCategory('all')}
//               >
//                 All Photos
//               </button>
//               {categories.map(category => (
//                 <button
//                   key={category}
//                   className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
//                   onClick={() => setSelectedCategory(category)}
//                 >
//                   {category.charAt(0).toUpperCase() + category.slice(1)}
//                 </button>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Gallery Grid */}
//       <section className="gallery-grid-section py-12">
//         <div className="container">
//           {filteredItems.length === 0 ? (
//             <div className="text-center py-12">
//               <div className="text-gray-400 text-6xl mb-4">🖼️</div>
//               <h3 className="text-2xl font-bold text-gray-900 mb-2">No images found</h3>
//               <p className="text-gray-600">Try selecting a different category</p>
//             </div>
//           ) : (
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
//               {filteredItems.map((item, index) => (
//                 <motion.div
//                   key={item._id}
//                   initial={{ opacity: 0, scale: 0.9 }}
//                   animate={{ opacity: 1, scale: 1 }}
//                   transition={{ delay: index * 0.05 }}
//                   className="relative group cursor-pointer"
//                   onClick={() => openLightbox(item)}
//                 >
//                   {/* Image */}
//                   <div className="aspect-square overflow-hidden rounded-lg bg-gray-200">
//                     <img
//                       src={item.image.startsWith('http') ? item.image : `https://agri-back-mauve.vercel.app${item.image}`}
//                       alt={item.title}
//                       className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
//                     />
//                   </div>
                  
//                   {/* Overlay */}
//                   <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 transition-all duration-300 rounded-lg flex items-center justify-center">
//                     <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex gap-2">
//                       <button className="bg-white p-2 rounded-full shadow-lg hover:bg-gray-100 transition-colors">
//                         <FiZoomIn size={20} />
//                       </button>
//                       <button className="bg-white p-2 rounded-full shadow-lg hover:bg-gray-100 transition-colors">
//                         <FiDownload size={20} />
//                       </button>
//                     </div>
//                   </div>
                  
//                   {/* Caption */}
//                   <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
//                     <h3 className="font-semibold text-sm">{item.title}</h3>
//                     {item.description && (
//                       <p className="text-xs text-gray-300 mt-1 line-clamp-2">
//                         {item.description}
//                       </p>
//                     )}
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           )}
//         </div>
//       </section>

//       {/* Lightbox Modal */}
//       <AnimatePresence>
//         {selectedImage && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
//             onClick={closeLightbox}
//           >
//             <motion.div
//               initial={{ scale: 0.8 }}
//               animate={{ scale: 1 }}
//               exit={{ scale: 0.8 }}
//               className="relative max-w-4xl max-h-full"
//               onClick={(e) => e.stopPropagation()}
//             >
//               {/* Close Button */}
//               <button
//                 onClick={closeLightbox}
//                 className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors z-10"
//               >
//                 <FiX size={24} />
//               </button>
              
//               {/* Image */}
//               <img
//                 src={selectedImage.image.startsWith('http') ? selectedImage.image : `https://agri-back-mauve.vercel.app${selectedImage.image}`}
//                 alt={selectedImage.title}
//                 className="max-w-full max-h-[80vh] object-contain rounded-lg"
//               />
              
//               {/* Caption */}
//               <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-6 text-white">
//                 <h3 className="text-xl font-bold mb-2">{selectedImage.title}</h3>
//                 {selectedImage.description && (
//                   <p className="text-gray-300">{selectedImage.description}</p>
//                 )}
//                 {selectedImage.galleryType && (
//                   <div className="mt-2">
//                     <span className="inline-block bg-green-600 text-white text-sm px-2 py-1 rounded">
//                       {selectedImage.galleryType}
//                     </span>
//                   </div>
//                 )}
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* CTA Section */}
//       <section className="gallery-cta bg-gray-900 py-12">
//         <div className="container">
//           <motion.div
//             initial={{ opacity: 0, scale: 0.9 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             className="text-center text-white"
//           >
//             <h2 className="text-3xl font-bold mb-4">Want to See More?</h2>
//             <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
//               Explore our complete portfolio of agricultural technology implementations and success stories
//             </p>
//             <div className="flex flex-col sm:flex-row gap-4 justify-center">
//               <a
//                 href="/projects"
//                 className="bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors"
//               >
//                 View Projects
//               </a>
//               <a
//                 href="/contact"
//                 className="border border-gray-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors"
//               >
//                 Request Site Visit
//               </a>
//             </div>
//           </motion.div>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Gallery;

// public/src/pages/Gallery.jsx - UPDATED WITH PROFESSIONAL STYLING & DARK MODE
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiFilter, FiX, FiZoomIn, FiArrowLeft, FiGrid } from 'react-icons/fi';
import axios from 'axios';

function Gallery() {
  const [galleryItems, setGalleryItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGallery();
  }, []);

  useEffect(() => {
    filterGallery();
  }, [galleryItems, selectedCategory]);

  const fetchGallery = async () => {
    try {
      const response = await axios.get('https://agri-back-mauve.vercel.app/api/content/public/gallery');
      if (response.data.success) {
        const galleryItems = response.data.data;
        setGalleryItems(galleryItems);
        
        // Extract unique categories safely
        const uniqueCategories = [...new Set(
          galleryItems
            .map(item => item.gallery?.galleryType || item.galleryType)
            .filter(type => type)
        )];
        setCategories(uniqueCategories);
      }
    } catch (error) {
      console.error('Error fetching gallery:', error);
    } finally {
      setLoading(false);
    }
  };

  const filterGallery = () => {
    if (selectedCategory === 'all') {
      setFilteredItems(galleryItems);
    } else {
      setFilteredItems(galleryItems.filter(item => 
        (item.gallery?.galleryType || item.galleryType) === selectedCategory
      ));
    }
  };

  const openLightbox = (item) => {
    setSelectedImage(item);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading gallery...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="gallery-page min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Hero Section */}
      <section className="page-hero bg-gradient-to-r from-green-900 to-emerald-800 text-white py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
              Project Gallery
            </h1>
            <p className="text-xl md:text-2xl text-gray-200 leading-relaxed">
              Visual journey through our innovative agricultural technology implementations and success stories across Africa
            </p>
          </motion.div>
        </div>
      </section>

      {/* Category Filters */}
      <section className="filters-section py-8 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm border-b border-green-100 dark:border-green-800 sticky top-0 z-10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="filters-container flex flex-col lg:flex-row gap-6 items-center justify-between">
            <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
              <FiFilter className="text-green-600 dark:text-green-400" />
              <span className="font-medium">Filter by category:</span>
            </div>
            
            <div className="category-filters flex flex-wrap gap-3 justify-center">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`filter-btn px-6 py-3 rounded-2xl font-semibold transition-all duration-300 flex items-center gap-2 ${
                  selectedCategory === 'all'
                    ? "bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-lg shadow-green-200 dark:shadow-green-900"
                    : "bg-white dark:bg-gray-700 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-600 hover:border-green-400 dark:hover:border-green-400 hover:shadow-md"
                }`}
                onClick={() => setSelectedCategory('all')}
              >
                <FiGrid className="w-4 h-4" />
                All Photos
              </motion.button>
              
              {categories.map(category => (
                <motion.button
                  key={category}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className={`filter-btn px-6 py-3 rounded-2xl font-semibold transition-all duration-300 ${
                    selectedCategory === category
                      ? "bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-lg shadow-green-200 dark:shadow-green-900"
                      : "bg-white dark:bg-gray-700 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-600 hover:border-green-400 dark:hover:border-green-400 hover:shadow-md"
                  }`}
                  onClick={() => setSelectedCategory(category)}
                >
                  {category && category.charAt ? category.charAt(0).toUpperCase() + category.slice(1) : 'Other'}
                </motion.button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="gallery-grid-section py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {filteredItems.length === 0 ? (
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              className="no-results text-center py-16"
            >
              <div className="max-w-md mx-auto">
                <div className="w-24 h-24 mx-auto mb-6 bg-green-100 dark:bg-green-800 rounded-full flex items-center justify-center">
                  <FiGrid className="w-12 h-12 text-green-600 dark:text-green-400" />
                </div>
                <h3 className="text-2xl font-bold text-gray-700 dark:text-gray-300 mb-3">
                  No images found
                </h3>
                <p className="text-gray-500 dark:text-gray-400 mb-6">
                  Try selecting a different category
                </p>
                <button
                  onClick={() => setSelectedCategory('all')}
                  className="px-6 py-3 bg-green-600 text-white rounded-2xl hover:bg-green-700 transition-colors duration-300 font-semibold"
                >
                  Show All Images
                </button>
              </div>
            </motion.div>
          ) : (
            <>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="results-info mb-8 text-center"
              >
                <p className="text-green-700 dark:text-green-300 font-semibold">
                  Showing {filteredItems.length} image{filteredItems.length !== 1 ? 's' : ''}
                  {selectedCategory !== 'all' && ` in ${selectedCategory}`}
                </p>
              </motion.div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {filteredItems.map((item, index) => (
                  <motion.div
                    key={item._id}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: index * 0.05 }}
                    className="group relative cursor-pointer"
                    onClick={() => openLightbox(item)}
                  >
                    {/* Image Container */}
                    <div className="aspect-square overflow-hidden rounded-2xl bg-gray-200 dark:bg-gray-700 shadow-lg hover:shadow-2xl transition-all duration-500">
                      <img
                        src={item.image?.startsWith('http') ? item.image : `https://agri-back-mauve.vercel.app${item.image}`}
                        alt={item.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      
                      {/* Overlay */}
                      <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-300 rounded-2xl flex items-center justify-center">
                        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform translate-y-4 group-hover:translate-y-0">
                          <div className="bg-white dark:bg-gray-800 p-3 rounded-full shadow-2xl">
                            <FiZoomIn className="w-6 h-6 text-green-600 dark:text-green-400" />
                          </div>
                        </div>
                      </div>
                      
                      {/* Category Badge */}
                      <div className="absolute top-3 left-3">
                        <span className="category-badge px-3 py-1 bg-white/90 dark:bg-gray-800/90 text-green-700 dark:text-green-300 rounded-full text-xs font-semibold backdrop-blur-sm">
                          {item.gallery?.galleryType || item.galleryType || 'Gallery'}
                        </span>
                      </div>
                    </div>
                    
                    {/* Caption - Only shown on hover */}
                    {(item.title || item.description) && (
                      <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 via-black/40 to-transparent text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-b-2xl">
                        {item.title && (
                          <h3 className="font-semibold text-sm mb-1 line-clamp-1">{item.title}</h3>
                        )}
                        {item.description && (
                          <p className="text-xs text-gray-300 line-clamp-2">{item.description}</p>
                        )}
                      </div>
                    )}
                  </motion.div>
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      {/* Lightbox Modal */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/95 dark:bg-black/98 z-50 flex items-center justify-center p-4"
            onClick={closeLightbox}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              className="relative max-w-6xl max-h-full w-full"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                onClick={closeLightbox}
                className="absolute -top-16 right-0 text-white hover:text-gray-300 transition-colors z-10 bg-black/50 rounded-full p-2 backdrop-blur-sm"
              >
                <FiX size={28} />
              </button>
              
              {/* Image Container */}
              <div className="bg-white dark:bg-gray-800 rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src={selectedImage.image?.startsWith('http') ? selectedImage.image : `https://agri-back-mauve.vercel.app${selectedImage.image}`}
                  alt={selectedImage.title}
                  className="w-full max-h-[70vh] object-contain"
                />
                
                {/* Caption - Clean and minimal at bottom */}
                {(selectedImage.title || selectedImage.description) && (
                  <div className="p-6 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
                    <div className="max-w-4xl mx-auto">
                      {selectedImage.title && (
                        <h3 className="text-xl font-bold text-gray-800 dark:text-white mb-2">
                          {selectedImage.title}
                        </h3>
                      )}
                      {selectedImage.description && (
                        <p className="text-gray-600 dark:text-gray-300">
                          {selectedImage.description}
                        </p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* CTA Section */}
      <section className="gallery-cta py-20 bg-gradient-to-r from-green-900 to-emerald-800">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7 }}
            className="cta-content text-center max-w-4xl mx-auto text-white"
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Want to See More?
            </h2>
            <p className="text-xl text-green-200 mb-8 leading-relaxed">
              Explore our complete portfolio of agricultural technology implementations and success stories from across Africa.
            </p>
            <div className="cta-buttons flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/projects"
                className="cta-button primary inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-2xl font-bold text-lg hover:from-green-600 hover:to-emerald-600 transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                View Projects
              </a>
              <a
                href="/contact"
                className="cta-button secondary inline-flex items-center justify-center px-8 py-4 bg-white text-green-700 rounded-2xl font-bold text-lg hover:bg-green-50 transition-all duration-300 border border-transparent hover:border-green-200"
              >
                Request Site Visit
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default Gallery;